module.exports = __webpack_public_path__ + "img/5.e0d576c6.png";